import type { ReviewVoteRequestVote } from './reviewVoteRequestVote';

/**
 * 리뷰 투표 요청
 */
export interface ReviewVoteRequest {
  /** 투표 유형 */
  vote: ReviewVoteRequestVote;
}
